module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrow-right-951b74b3ffe21b923422d92cadfbc593.svg";